import React, { useContext, useMemo } from 'react';

import cookie from 'react-cookies';
import { NotificationManager } from 'react-notifications';
import { useNavigate, Outlet, useLocation } from 'react-router';
import ClipLoader from 'react-spinners/ClipLoader';

import Footer from './Footer';
import Header from './Header';

import { getTenant } from '../../config';
import { UserContext } from '../../context/UserContext';
import { cleanUpSessionData } from '../../helpers/applicationHelp';
import { useRudder } from '../../hooks/rudder';
import { refreshToken } from '../../service/api';
import { signOut } from '../../service/profile';
import ExtendSessionModal from '../ExtendSessionModal';

const Layout = ({ children }) => {
  const {
    loading,
    setToken,
    setProfile,
    authHeaderBeakpoint,
    showSessionExtendModal,
    setShowSessionExtendModal,
  } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const query = useMemo(() => new URLSearchParams(location.search), [location]);
  const destination = query.get('app');
  const { errorEvent } = useRudder();

  const renderLayout = () => {
    return (
      (destination !== '/admin' && getTenant() !== 'lightrx') || location.pathname == '/dashboard'
    );
  };

  const renderLoading = () => {
    return destination === '/admin' || getTenant() !== 'lightrx';
  };

  const logout = async () => {
    setShowSessionExtendModal(false);
    NotificationManager.warning('Your session has expired', 'Warning', 10000);
    try {
      await signOut();
    } catch (e) {
      console.log('signout error', e);
    }
    cleanUpSessionData();
    if (!location.pathname.startsWith('/landing') || !location.pathname.startsWith('/auth')) {
      setProfile({});
      navigate(`/auth/sign-in?app=${location.pathname}`);
    }
  };

  const launchRefresh = () => {
    refreshToken()
      .then((res) => {
        cookie.save('lendistry_tokens_access', res.data.accessToken, {
          path: '/',
        });
        cookie.save('lendistry_tokens_refresh', res.data.refreshToken, {
          path: '/',
        });
        setToken(res.data.accessToken);
      })
      .catch((err) => {
        console.log(err);
        errorEvent('Error API', err);
        logout();
      });
    setShowSessionExtendModal(false);
  };

  return (
    <div className="landing-page">
      {loading && renderLoading() && (
        <div className="custom-spinner">
          <ClipLoader color="white" loading={loading} size={70} />
        </div>
      )}
      {showSessionExtendModal && (
        <ExtendSessionModal logout={() => logout()} launchRefresh={() => launchRefresh()} />
      )}
      {renderLayout() && <Header breakpoint={authHeaderBeakpoint} />}
      <div className={`layout-content ${getTenant()}`}>
        <Outlet />
        {children}
      </div>
      {renderLayout() && <Footer breakpoint={authHeaderBeakpoint} />}
    </div>
  );
};

export default Layout;
